"use strict";import{IconCheckmark200 as e}from"../src/elements/IconCheckmark200.js";import{defineElement as c}from"@spectrum-web-components/base/src/define-element.js";c("sp-icon-checkmark200",e);
//# sourceMappingURL=sp-icon-checkmark200.js.map
